<script lang="ts">
  import { currentPoints, points } from '../stores/scores';
</script>

<style>
  ul {
    display: flex;
    flex-direction: row-reverse;
    list-style: none;
    justify-content: center;
  }

  ul > * + * {
    margin-right: 0.5rem;
  }

  li {
    --points-size: 2.5rem;
    background-color: rgb(74,109,163);
    border-radius: 0.25rem;
    color: white;
    display: grid;
    height: var(--points-size);
    place-items: center;
    width: var(--points-size);
  }

  .current {
    background-color: bisque;
    color: black;
    font-weight: bold;
  }

  .used {
    background-color: rgb(54, 59, 66);
  }

  @media (max-width: 70rem) {
    ul {
      padding: 0.5rem;
    }
  }
</style>

<ul>
  {#each points as point, idx (point)}
    <li class:current={$currentPoints === idx} class:used={idx < $currentPoints}>{point}</li>
  {/each}
</ul>
